import { FlatActionList } from "@towersystems/roam-common-native";
import { MfaCodeStrategy } from "@towersystems/roam-common/lib/generated-types";
import React from "react";
import { MfaStrategies } from "@towersystems/roam-common-native/lib/components/LoginForm/constants";

export interface MfaMethodRadioButtonsProps {
  onChange: (value: string) => void;
  strategies: MfaCodeStrategy[];
  value?: string;
}

export const MfaMethodOptions = ({
  strategies,
  onChange,
}: MfaMethodRadioButtonsProps) => {
  const items = strategies.map((i) => {
    return {
      key: i,
      title: MfaStrategies[i]?.title,
      subTitle: MfaStrategies[i]?.description,
      onPress: () => onChange(i),
    };
  });

  return <FlatActionList items={items} />;
};
